import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { ICompany } from 'src/app/shared/models/company.model';
import {
  IUser,
  UserPermissionResponse
} from 'src/app/shared/models/login.model';
import { imgUrl } from 'src/app/shared/globals/app-constants';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';
import { environment } from 'src/environments/environment';
import { UnsubscribeOnDestroyAdapter } from 'src/app/core/unsuscribe-adapter/unsuscribe-adapter';
import { ToolbarService } from 'src/app/shared/services/toolbar.service';
import {
  INotification,
  ISummaryNotifications
} from 'src/app/shared/models/notifications.model';
import { NavigationEnd, Router } from '@angular/router';
import { SocketService } from '@shared/services/socket.service';
import { IEvent as Event } from '@shared/models/socket.mode';
import { HttpService } from 'src/app/core/http/http.service';
import { MatDialog } from '@angular/material';
import { DownloadReportsComponent } from './download-reports/download-reports.component';
import { UserService } from '@shared/services/user.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  providers: [SocketService]
})
export class ToolbarComponent extends UnsubscribeOnDestroyAdapter
  implements OnInit {
  @Output()
  toggleHideSidebar = new EventEmitter<Object>();
  public company: ICompany;
  public offset = -5;
  public showNotify = false;
  public notifications: INotification[] = [];
  public storePendingNotifications: INotification[] = [];
  public openNotifictionsFirstTime: boolean = false;
  public notificationsSummary: number = 0;
  public user: IUser;
  public environmentUrl = imgUrl;
  public activeView: string;
  public summaryView: number;
  public paymentSummary: number;
  public resourcesUrl: string = imgUrl;
  public renderLeadsBack = false;
  private compareDates = (a, b) => {
    if (a.createdAt > b.createdAt) {
      return -1;
    }
    if (a.createdAt < b.createdAt) {
      return 1;
    }
    return 0;
  };
  userPermission: UserPermissionResponse;

  constructor(
    private authenticationService: AuthenticationService,
    private toolbarService: ToolbarService,
    private router: Router,
    private socketService: SocketService,
    private service: HttpService,
    private dialog: MatDialog,
    private userService: UserService
  ) {
    super();
    this.company = JSON.parse(localStorage.getItem('COMPANY_INFO'));
    this.user = this.userService.userInfo;
    this.userPermission = this.userService.userPermissionInfo;
  }

  ngOnInit() {
    this.listenServiceToolbar();
    this.getNotificationsSummary();
    this.initSocketConnection();
    this.listenRouterNavigation();
  }

  private listenRouterNavigation(): void {
    this.subs.add(
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          const array = event.url.split('/');
          this.renderLeadsBack =
            (array.includes('create') || array.includes('edit')) &&
            array.includes('leads')
              ? true
              : false;
        }
      })
    );
  }

  private listenServiceToolbar() {
    this.subs.add(
      this.toolbarService.getViewActive().subscribe((activeView: string) => {
        this.activeView = activeView;
      })
    );
    this.subs.add(
      this.toolbarService.getSummaryView().subscribe((summaryView: number) => {
        this.summaryView = summaryView;
      })
    );

    this.subs.add(
      this.toolbarService
        .getPaymentSummary()
        .subscribe((paymentSummary: number) => {
          this.paymentSummary = paymentSummary;
        })
    );
  }

  toggleSidebar() {
    const appSidebar = document.getElementsByClassName('app-sidebar')[0];
    if (appSidebar.classList.contains('hide-sidebar')) {
      this.toggleHideSidebar.emit(false);
    } else {
      this.toggleHideSidebar.emit(true);
    }
  }

  settings() {
    this.router.navigate(['/main/settings']);
  }

  public logout(): void {
    sessionStorage.removeItem('historyNavigation');
    this.authenticationService.logout();
    window.location.href = environment.domainLoginPortal;
  }

  private initSocketConnection(): void {
    this.socketService.initSocket(
      environment.socketUrl + '/CLIENTOPERATOR',
      localStorage.getItem('JWT_TOKEN')
    );
    this.subs.add(this.socketService.onEvent(Event.CONNECT).subscribe(e => {}));
    this.subs.add(
      this.socketService
        .onEvent('op-notification-' + this.user.id)
        .subscribe(notification => {
          const formattingNotification: INotification = {
            id: notification.notification_id,
            createdAt: notification.created_at,
            NotificationApp: {
              ...notification
            }
          } as any;
          if (!this.showNotify) {
            this.notificationsSummary = this.notificationsSummary + 1;
          }
          if (this.openNotifictionsFirstTime) {
            this.notifications = [
              formattingNotification,
              ...this.notifications
            ].slice(0, 10);
          }
          if (this.openNotifictionsFirstTime && !this.showNotify) {
            this.storePendingNotifications.push(formattingNotification);
          }
        })
    );
  }

  resetStoreNotifications() {
    setTimeout(() => {
      this.storePendingNotifications = [];
    }, 100);
  }

  setNotification(event: INotification[]) {
    this.notifications.push(...event);
    this.notifications = [...this.notifications.sort(this.compareDates)];
    this.openNotifictionsFirstTime = true;
  }

  getNotificationsSummary(): void {
    this.subs.add(
      this.service
        .get<ISummaryNotifications>('notification/summary', {})
        .subscribe(rest => (this.notificationsSummary = rest.total))
    );
  }

  openDownloadReportsModal(): void {
    this.dialog.open(DownloadReportsComponent, {
      width: '420px',
      height: 'auto',
      panelClass: 'create-task-modal'
    });
  }
}
